import React from 'react';
import PropTypes from 'prop-types';
import marked from 'marked';
import clsx from 'clsx';

const renderer = new marked.Renderer();
const linkRenderer = renderer.link;
renderer.link = (href, title, text) => {
  const html = linkRenderer.call(renderer, href, title, text);
  return html.replace(/^<a /, '<a target="_blank" rel="nofollow" ');
};

const Label = ({ children, htmlFor, className, required, ...props }) => (
  <label
    className={clsx(
      className,
      'block',
      '[font-weight:var(--cp_checkout-form-fields-label-font-weight)]',
      '[padding-bottom:var(--cp_checkout-form-fields-label-padding-bottom)]',
      required && 'after:content-["*"] after:ml-0.5',
    )}
    htmlFor={htmlFor}
    {...props}
    dangerouslySetInnerHTML={{ __html: marked.parseInline(children, { renderer }) }}
  />
);

Label.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  htmlFor: PropTypes.string,
};

Label.defaultProps = {
  htmlFor: '',
};

export default Label;
